module.exports = __webpack_public_path__ + "assets/close-circular-button-symbol.svg";